export default __webpack_public_path__ + "static/media/foto02.8d2a6934.png";